<template>
  <div class="select-series-style">
    <select v-model="selected" @change="$emit('select-style', selected)">
      <option value="0">סינון לפי סיגנון</option>
      <option
        v-for="style in categoryStyles"
        :key="style.id"
        :value="style.resource.id"
      >
        {{ style.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "0",
    };
  },
  computed: {
    categoryStyles() {
      let cs = [];

      switch (this.$route.params.catid) {
        case "1":
          cs = [
            "9",
            "19",
            "20",
            "22",
            "25",
            "26",
            "27",
            "28",
            "38",
            "926",
            "927",
            "928",
          ];
          break;

        case "2":
          cs = ["21", "134", "386", "476", "477", "930", "931"];
          break;
        case "3":
          cs = ["9", "19", "20", "38", "927", "928"];
          break;
        case "4":
          cs = ["21", "134", "386", "477", "930", "931", "385"];
          break;
        case "5":
          cs = ["21", "134", "20", "19", "146", "286", "477"];
          break;
        case "6":
          cs = ["21", "26", "476", "20"];
          break;
        case "7":
          cs = ["476", "27", "26", "386", "21", "38"];
          break;
        case "8":
          cs = ["28", "22", "146", "926", "147", "27", "26", "21", "386"];
          break;
        case "9":
          cs = ["24", "23", "227", "724", "932", "386", "25"];
          break;
      }

      return this.$store.state.initialData.currents.filter(style =>
        cs.includes(style.resource.id)
      );
    },
  },
};
</script>

<style lang="scss">
.select-series-style {
  text-align: center;
  select {
    background: transparent;
    border: 0;
    font-size: 1.1rem;
    max-width: 140px;
    option {
      font-size: 1rem;
    }
  }
}
</style>